import { Card, CardBody, Col } from "reactstrap";
import { H4, Image, SVG } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service";
import { Link } from "react-router-dom";
import YourInvestment from "./YourInvestment";
import { YourBalanceHeading } from "../../../../utils/Constant";

const YourBalance = () => {
  return (
    <Col xxl="3" xl="4" sm="6" className="box-col-6">
      <Card className="balance-box height-equal-2">
        <CardBody className="d-flex align-items-center justify-content-center">
          <div className="balance-profile">
            <div className="balance-img">
              <Image src={dynamicImage(`dashboard/user/user-boy.png`)} alt="user vector" />
              <Link className="edit-icon" to={`${process.env.PUBLIC_URL}/users/userprofile`}>
                <SVG iconId="pencil" />
              </Link>
            </div>
            <span className="f-light d-block">{YourBalanceHeading} </span>
            <H4 className="mt-1">$768,987.90</H4>
            <YourInvestment />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default YourBalance;
